import React from "react";
import { CreateAccountForm } from "../../components/CreateAccount/CreateAccountForm";

const CreateAccountPage: React.FC<{ setPathname: () => void }> = ({
  setPathname,
}) => <CreateAccountForm setPathname={setPathname} />;

export default CreateAccountPage;
